import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const loadDictionary = async () => {
  try {
    const response = await fetch("/dictionary.txt");
    if (!response.ok) {
      throw new Error("Failed to load dictionary");
    }
    const text = await response.text();
    const words = text.split("\n").map((word) => word.trim().toUpperCase());
    return new Set(words);
  } catch (error) {
    console.error("Error loading dictionary:", error);
    return new Set();
  }
};
